import { PerkDefinition } from "./types";

export const perkRage = {
  id: "perk_rage",
  name: "Rage",
  description: "When you take damage, gain +1 ATK this combat.",
  apply: () => {
    // No stat modifications on apply
  },
  onDamageTaken: (_damageAmount, context) => {
    // Gain 1 ATK per stack when taking damage (permanent for this combat)
    context.applyAttackBuff(context.stackCount * 1);
    return 0; // No healing
  },
} satisfies PerkDefinition<"perk_rage">;
